module.exports = {
    welcome: "Welcome",
    menu: "menu",
    home: "home",
    dashboard: "Dashboard",
    Posts: "Posts",
    Create: "Create",
    post: "post",
    view: "View",
    login: "Login",
    language: "language",
    edit: "Edit",
    delete: "delete",
    action: "action",
    prefix: "prefix",
    save: "Save",
    categories: "categories",
    seo: "Seo",
    title: "title",
    select: "Select",
    slug: "slug",
    short: "short",
    content: "content",
    table: "table",
    tables: "tables",
    quantity: "quantity",
    photo: "photo",
    choose: "choose",
    file: "file",
    update: "Updated",
    result: "Result",
    scheme: "scheme",
    database: "database",
    settings: "settings",
    controll: "controll",
    tariff: "tariff",
    add: "add",
    advices: "advices",
    advice: "advice",
    feedback: "feedback",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    /* nerqev */
    contact: "Contact",
    contacts: "Contacts",
    about_as: "About as",
    Just_3_simple_steps: "Just 3 simple steps!",
    download: "Download",
    Create_your_resume_right_now: "Create your own resume sample for job and download for free",
    cv_editor_message: "Our site is highly recommended to create a resume online. This is a simple, fast and also free way to creat a dream resume. Comfortable and simple interface will allow to create a resume even by the most inexperienced computer user. Intuitively, you can create a professional and most accurate resume for your future workplace. After you done with a resume, you can easily place it everywhere.",
    Create_your_resume_large_text:
        "CVWEB offers you ideal and creative ways to make your CV. This will allow you to organize your portfolio correctly. Who knows, it can drasticly change your life. HR specialists recommend our site as one of the best. Each applicant can find his own sample to work with. Follow our advice and create most creative resume ever.",
    resume: "CV",
    created: "Created",
    blog: "Blog",
    CV_in: "CV in",
    minutes: "minutes",
    Popular_posts: "Popular posts",
    Our_advice: "Our advice",
    bestseller: "Bestseller",
    Your_feedback: "Your feedbacks",
    our_feedback:  "Your feedback",
    Read_more: "Read more",
    write_us: "Write us",
    create_resume: "Create resume",
    send: "Send",
    email_error: "Invalid email",
    email: "Email",
    find_your_account: "Restore your profile",
    password: "Password",
    password_confirmation: "Password confirmation",
    new_password: "New password",
    registration: "Registration",
    sign_in: "Sign in",
    remamber_me: "Remamber me",
    forgot_password: "Forgot password?",
    name: "First name",
    surname: "Surname",
    logout: "Logout",
    change_password: "Change password",
    old_password: "Old password",
    basic_info: "Basic info",
    job_stack: 'Job stack',
    profession: "Professions",
    skills: "Skills",
    languages: "Languages",
    hobby: "Hobbies",
    education: "Education",
    work_experience: "Work experience",
    social: 'Social networks',
    citizen: "Citizenship",
    cv_contact: "Contacts",
    career_objective: "Career goals",
    year: "Year",
    phone: "Phone number",
    birthday: "Birthday",
    ardess: "Adress",
    start: "Start",
    end: "End",
    company: "Company",
    specialization: "Specialization",
    university: "University education",
    faculty: "Faculty",
    location: "Location",
    description: "Description",
    from: "From",
    full_stack: "Full stack",
    contractual: "Contract",
    our_advices: "Our advices",
    category: "Category",
    we_in_social: "We in social media",
    crweb_address: "Tpagrichner 4 <br><br> Yerevan, Armenia 0010",
    vacancy: "Job",
    present: "Present",
    monthly: "Monthly",
    select_empty: "List is empty",
    facebook_foot_link : "https://www.facebook.com/CVwebUSA",
    instagram_foot_link: "https://www.instagram.com/cvweb_",
    achievement: "Achievements",
    conditions : "Conditions",
    no_elements: "No elements found.",
    new_user_created: "New user is created",
    you_accounts_has_merged: "Your accounts has been merged",
    CV_language: 'Language',
    course:'$',
    //errors
    invalid_email: 'Incorrect email',
    invalid_password: 'Incorrect password',
    invalid_password_confirmation: 'Invalid password confirmation',
    policy: 'Privacy policy',
    policy_title: 'POLICY THE PROCESSING <br> OF PERSONAL DATA LLC<br> CREATIVE WEB»',
    Last_edited : 'Yours cvs',
    Zoom : 'Zoom',
    Rotation : 'Rotation',
    teoken_sended : 'Link password recovery sent to the mail.',
    please_verify : 'Please verify',
    'The photo may not be greater than 10240 kilobytes.':'The photo may not be greater than 10 megabytes..',
    specialist_consultant:'Specialist consultant',
    message_title:'Enter your message',
    themes: "Themes",
    sorry_404: 'Sorry, but the page you are looking for doesn\'t exist.',
    backtohomepage: 'Back to homepage',
    thanks_d: ' Thank You for<br>choosing us',
    payment_error:'Payment has not been made, check your card details and try again.',
    payment_message: 'Payment message',
    authentication_fails: 'Incorrect data',
    day: 'd.',
    hour: 'հ.',
    transfer: 'Transfer',
    old_password_invalid: "Old password is invalid",
    attention: "Attention!",
    success: "Successfully!",
    changed: "Password is changed",
    recover: "Recover",
    error: "Unsuccessful",
    shear_text: "Or tell your friends about us and get a free rate",
    registration_success: "You have successfully registered",
    server_error: "Try again, something went wrong",
    save_resume: "Everything is fine, the resume is preserved",
    cv_delete: "Resume is deleted",
    image_change: "The picture is saved",
    sent_message: "The letter was sent",
    input_promo_code: "Enter a promo code",
    promo_code: "Promo code",
    new__cv: "Create new",
    go__cvs: "Created cvs",
    there__are__cv: "You already have this type of resume: <br/> Do you want to create a new one?"
};



// WEBPACK FOOTER //
// ./resources/js/lang/en.js